import { invokeApi } from "../bl_libs/invokeApi";
import { LOCAL_STORAGE_KEYS } from "../utils/constants";

export const PaymantInfoService = async () => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dqseal_client/billing/billing_info',
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    return await invokeApi(requestObj);
};



// Stripe 
export const CreatePaymentIntentService = async (data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dqseal_client/billing/create_payment_intent',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
    };
    requestObj['postData'] = data;

    return await invokeApi(requestObj);
};

export const UpdateBillingOrgService = async (data) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path: '/dqseal_client/billing/update_payment_billing',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
    };
    requestObj['postData'] = data;

    return await invokeApi(requestObj);
}